import { propertyAccessor } from '../../../common/components/properties/Properties'
import {
  date,
  orderPurchaseOrderNumber,
  orderSalesOrderNumber,
  plannedUnits,
} from '../../../common/utils/formatter'
import { XlsxColumn } from '../../../common/components/export/ExportService'
import {
  EnrichedDeliveryNote,
  FulfillmentRequestInstruction,
  FulfillmentRequestParty,
} from '../../../generated/graphql'
import { getShippingPointName } from '../../shipment/ShippingPoints'
import { isActiveXDockShippingPoint } from '../../shipment/ShipmentFlags'

export const ordersXlsxColumns: XlsxColumn[] = [
  {
    header: 'Delivery Note',
    toStringFunction: propertyAccessor(
      'deliveryNote.fulfillmentRequestHeader.fulfillmentRequestNumber'
    ),
  },
  {
    header: 'Packlist',
    toStringFunction: propertyAccessor('shipments.packlistNumber'),
  },
  {
    header: 'Sales Order',
    toStringFunction: (order) => orderSalesOrderNumber(order),
  },
  {
    header: 'Order Type',
    toStringFunction: propertyAccessor('deliveryNote.fulfillmentRequestHeader.orderType'),
  },
  {
    header: 'Purchase Order Number',
    toStringFunction: (order) => orderPurchaseOrderNumber(order),
  },
  {
    header: 'Shipping Point',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      order.deliveryNote.fulfillmentRequestHeader.shippingPointCode,
  },
  {
    header: 'Shipping Point Name',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      getShippingPointName(Number(order.deliveryNote.fulfillmentRequestHeader.shippingPointCode)),
  },
  {
    header: 'Ship To',
    toStringFunction: (order) => getShipTo(order)?.partyIdentifier,
  },
  {
    header: 'Ship To Name',
    toStringFunction: (order: EnrichedDeliveryNote) => getShipTo(order)?.partyName1,
  },
  {
    header: 'Ship To Country',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      getShipTo(order)?.fulfillmentRequestLocationAddress?.countryCode,
  },
  {
    header: 'CMR',
    toStringFunction: propertyAccessor('shipments.proNumbers'),
  },
  {
    header: 'Traffic Instructions',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      getTrafficInstructions(order)?.instruction1Text,
  },
  {
    header: '# Planned Units',
    toStringFunction: (order: EnrichedDeliveryNote) => String(plannedUnits(order)),
  },
  {
    header: 'Planned Shipped Date',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      date(
        order.deliveryNote.fulfillmentRequestHeader.fulfillmentRequestDate
          .plannedGoodsIssueTimestamp,
        { showTime: false }
      ),
  },
  {
    header: 'Planned Delivery Date',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      date(
        order.deliveryNote.fulfillmentRequestHeader.fulfillmentRequestDate
          .deliveryPlanScheduledDeliveryDate,
        { showTime: false }
      ),
  },
  {
    header: 'Export',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      order.deliveryNote.fulfillmentRequestHeader.exportIndicator ? 'Y' : 'N',
  },
  {
    header: 'One-time-shipment',
    toStringFunction: (order: EnrichedDeliveryNote) =>
      order.deliveryNote.fulfillmentRequestHeader.shipToAddressOverrideIndicator ? 'Y' : 'N',
  },
]

function getShipTo(order: EnrichedDeliveryNote): FulfillmentRequestParty {
  return order.deliveryNote.fulfillmentRequestHeader.fulfillmentRequestParty?.find(
    (p) => p.partyTypeCode === 'SHIP_TO'
  )
}

function getTrafficInstructions(order: EnrichedDeliveryNote): FulfillmentRequestInstruction {
  return order.deliveryNote.fulfillmentRequestHeader.fulfillmentRequestInstruction?.find(
    (i) => i.instructionCode === 'ZIDP'
  )
}
